
import { sanitizeInput } from './inputValidation';

export class GprofileValidation {
  static isValidUUID(uuid: string): boolean {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
  }

  static validateInputs(userId: string | undefined, user: any): string | null {
    if (!userId || !user) {
      console.log('❌ No userId or user provided');
      return 'No user ID provided or not authenticated';
    }

    // Sanitize the userId input to prevent injection attacks
    const sanitizedUserId = sanitizeInput(userId);
    
    if (!this.isValidUUID(sanitizedUserId)) {
      console.log('❌ Invalid UUID format:', sanitizedUserId);
      return 'Invalid user ID format';
    }

    // Additional security check - prevent access to system accounts
    if (sanitizedUserId === '00000000-0000-0000-0000-000000000000' || 
        sanitizedUserId.startsWith('system-') ||
        sanitizedUserId.includes('admin')) {
      console.log('❌ Attempted access to restricted account:', sanitizedUserId);
      return 'Access denied';
    }

    return null;
  }

  static sanitizeProfileData(data: any): any {
    if (!data || typeof data !== 'object') return data;

    const sanitized = { ...data };
    
    // Sanitize string fields that could contain user input
    if (sanitized.display_name) {
      sanitized.display_name = sanitizeInput(sanitized.display_name);
    }
    if (sanitized.bio) {
      sanitized.bio = sanitizeInput(sanitized.bio);
    }
    if (sanitized.first_name) {
      sanitized.first_name = sanitizeInput(sanitized.first_name);
    }
    if (sanitized.last_name) {
      sanitized.last_name = sanitizeInput(sanitized.last_name);
    }
    if (sanitized.location) {
      sanitized.location = sanitizeInput(sanitized.location);
    }

    // Sanitize arrays of strings
    if (Array.isArray(sanitized.public_interests)) {
      sanitized.public_interests = sanitized.public_interests.map((interest: string) => 
        sanitizeInput(interest));
    }
    if (Array.isArray(sanitized.private_interests)) {
      sanitized.private_interests = sanitized.private_interests.map((interest: string) => 
        sanitizeInput(interest));
    }
    if (Array.isArray(sanitized.looking_for)) {
      sanitized.looking_for = sanitized.looking_for.map((item: string) => 
        sanitizeInput(item));
    }

    return sanitized;
  }
}
